export const validateCustomDynamicPropertyValue = (value: string) => {
	const regex = /^{{_(payload|url|headers)(\.[a-zA-Z0-9_]+)+}}$/;
	return regex.test(value);
};
